export const matchHeight = (elementClass) => {
    $(elementClass).matchHeight();
}
